import { NUMEROS_PROVA } from '../dados/numeros';
import { Numero } from './numero';
import { Reveal, RevealGrupo } from './reveal';
import { MarqueeConferencias } from './marquee-conferencias';

/**
 * Tira de prova logo após o herói: cada valor conta ao entrar na viewport
 * (`<Numero>`). Sem id/entrada no menu, como `<DoresSolucao>` — é reforço,
 * não uma seção de navegação.
 */
export function ProvaNumerica(): JSX.Element {
  return (
    <section
      aria-label="Números do sistema"
      className="border-auth-borda/8 border-t py-12"
    >
      <div className="mx-auto max-w-6xl px-6">
        <RevealGrupo
          className="grid grid-cols-2 gap-x-6 gap-y-8 sm:grid-cols-5"
          passoMs={60}
        >
          {NUMEROS_PROVA.map((item) => (
            <Reveal key={item.rotulo} className="flex flex-col gap-1.5">
              {/* GRANDE, como a referência que o dono apontou ("100+"): o
                  número é o argumento, o rótulo é legenda. */}
              <Numero
                valor={item.valor}
                className="text-auth-texto text-5xl tracking-tight sm:text-6xl"
              />
              <p className="text-auth-texto-terciario max-w-[14rem] text-xs leading-snug">
                {item.rotulo}
              </p>
            </Reveal>
          ))}
        </RevealGrupo>
      </div>

      {/*
        A tira NOMEIA o que os números contam — fora do contêiner de 6xl de
        propósito: o marquee corre de borda a borda, e a máscara nas pontas
        é quem o encerra visualmente.
      */}
      <Reveal direcao="parado" className="mt-10">
        <MarqueeConferencias />
      </Reveal>
    </section>
  );
}
